import { GlobalState } from "@Context/common/general/initial-state.types";
import ChallengeLeagueTags from "@Enums/ChallengeLeagueTags";
import { ChallengeTag } from "./types";

export const challengeTags: ChallengeTag[] = [
  { id: ChallengeLeagueTags.BOOTCAMP },
  { id: ChallengeLeagueTags.BRONZE },
  { id: ChallengeLeagueTags.SILVER },
  { id: ChallengeLeagueTags.GOLD },
  { id: ChallengeLeagueTags.CHAMPIONS },
  { id: ChallengeLeagueTags.DRILL },
];

export const superAdminTags: ChallengeTag[] = [{ id: ChallengeLeagueTags.QA }];

export const demoTag = { id: ChallengeLeagueTags.DEMO, color: "dsSuccess.v400" };

export const consolidateTagsForUser = (globalState: GlobalState, isDemo: boolean) => {
  const tags: ChallengeTag[] = [...challengeTags];
  if (globalState.user.isSuperAdmin) {
    tags.push(...superAdminTags);
  }
  if (isDemo) {
    tags.unshift(demoTag);
  }
  return tags;
};

export { getChallengeLocizeKeyPrefix } from "@Shared/schemas/challenges/challengeLocalizationSchemas";
